import React, { useContext, useState } from 'react';
// @ts-ignore
import pyyneLogo from '../../assets/images/logo-high-res-tree-only.png';
// @ts-ignore
import { CurrentUserContext } from '../../utils/contexts/current-user.context';
// @ts-ignore
import UserService from '../../utils/services/user-service';
import { Button } from '../ui/button';

function LoginForm() {
  const [loginParams, setLoginInfo] = useState({ email: '', password: '' });
  // const history = useHistory()
  // @ts-ignore
  const { getAxios, login } = useContext(CurrentUserContext);

  const postLogin = async (loginParams: {
    email: string;
    password: string;
  }) => {
    const { success, user } = await UserService.login(getAxios(), loginParams);
    if (success) {
      await login(user);
      // history.push('/consultants')
    }
  };

  return (
    <div className='flex relative w-full max-w-sm justify-center items-center p-8 rounded-2xl bg-[#E7FADACA]'>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          postLogin(loginParams);
        }}
      >
        <img src={pyyneLogo} alt='PYYNE Logo' className='mx-auto h-auto w-2/5' />
        <h2 className='text-center'>Login</h2>
        <div className='flex m-1 p-1'>
          <input
            type='email'
            name='email'
            placeholder='Email'
            id='email'
            onChange={(e) =>
              setLoginInfo({ ...loginParams, email: e.target.value })
            }
            value={loginParams.email}
            className='w-full p-1 rounded-lg'
          />
        </div>
        <div className='flex m-1 p-1'>
          <input
            type='password'
            name='password'
            placeholder='Password'
            id='password'
            onChange={(e) =>
              setLoginInfo({ ...loginParams, password: e.target.value })
            }
            value={loginParams.password}
            className='w-full p-1 rounded-lg'
          />
        </div>
        <div className='flex m-2 justify-center items-center p-1'>
          <Button type='submit'>Login</Button>
        </div>
        <Button variant={'link'} to='/send-password-reset'>
          Forgot Password?
        </Button>
      </form>
    </div>
  );
}

export default LoginForm;
